module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_arrow_triangle_down-21479c4d30ac78f30cda134e5807ad4f.svg";